// extracted by mini-css-extract-plugin
export default {"button":"styles_button__zzb-P","white":"styles_white__nL50A","bordered":"styles_bordered__mEGtJ","loaderWrap":"styles_loaderWrap__JDJ7H","margin":"styles_margin__Ig1dK"};